// @flow

import React from 'react';

import { populationFormater, dollarFormater, numericToString } from './Formatters';
import Tips from '../components/Tooltip/Tips';
import Tip from '../components/Tooltip/Tip';

const climateZoneDescriptions = {
  '1': 'Very Hot',
  '2': 'Hot',
  '3': 'Warm',
  '4': 'Mixed',
  '5': 'Cool',
  '6': 'Cold',
  '7': 'Very Cold',
  '8': 'Subartic',
};

const buildLocationTooltip = (d: Object, selectedMeasure: Object) => {
  const valueString = numericToString(d[selectedMeasure.key], selectedMeasure.formater);
  const countString = numericToString(d.UGDS, populationFormater);

  return (
    <Tips>
      <Tip label={d.INSTNM} />
      <Tip label="Students" value={countString} />
      <Tip label={selectedMeasure.label} value={valueString} />
    </Tips>
  );
};

const buildRegionTooltip = (d: Object) => {
  const { climateZone, count, medianHouseholdIncome, name } = d.properties;

  return (
    <Tips>
      <Tip label={name} />
      <Tip label="Population" value={populationFormater(count)} />
      <Tip label="Median Household Income" value={dollarFormater(medianHouseholdIncome)} />
      <Tip label="Climate Zone" value={climateZoneDescriptions[climateZone]} />
    </Tips>
  );
};

export { buildLocationTooltip, buildRegionTooltip };



// WEBPACK FOOTER //
// ./src/App/TooltipBuilders.js